import { render, staticRenderFns } from "./AttendancePageMonthlyTable.vue?vue&type=template&id=33327638&scoped=true&"
import script from "./AttendancePageMonthlyTable.vue?vue&type=script&lang=js&"
export * from "./AttendancePageMonthlyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33327638",
  null
  
)

export default component.exports